import { Button } from 'primereact/button';
import React from 'react';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';

const SuperMatchContactRequest = ({ superMatch, requestContact }) => {
  const { status } = superMatch;

  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  if (status === 'CONTACT_NOT_REQUESTED') {
    return <Button onClick={() => requestContact(superMatch.id)} label="Contact" disabled={subscriptionIsExpired} />;
  }

  if (status === 'CONTACT_REQUESTED') {
    return <p>Contact requested</p>;
  }

  return <></>;
};

export default SuperMatchContactRequest;
